// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FullSurveySessionPostRequestSessionValuesInner } from './fullSurveySessionPostRequestSessionValuesInner.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class FullSurveySessionPostRequest {
    'sessionValues'?: Array<FullSurveySessionPostRequestSessionValuesInner>;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof FullSurveySessionPostRequest>> = [
        {
            "name":     "sessionValues",
            "baseName": "sessionValues",
            "type":     "Array<FullSurveySessionPostRequestSessionValuesInner>"
        },
    ];

    static getAttributeTypeMap() {
        return FullSurveySessionPostRequest.attributeTypeMap;
    }
}
